const state = {
  isLoggedIn: false,
  userInfo: null,
  token: null,
  permission: null
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  userInfo: state => state.userInfo,
  permission: state => state.permission
}

const mutations = {
  SET_LOGIN_STATUS(state, { isLoggedIn, userInfo, token, permission }) {
    state.isLoggedIn = isLoggedIn
    state.userInfo = userInfo
    state.token = token
    state.permission = permission
  },
  LOGOUT(state) {
    state.isLoggedIn = false
    state.userInfo = null
    state.token = null
    state.permission = null
  }
}

const actions = {
  
  login({ commit }, userData) {
    commit('SET_LOGIN_STATUS', {
      isLoggedIn: true,
      userInfo: {
        username: userData.username,
        role: 'admin'
      },
      token: userData.token,
      permission: userData.permission
    })
    // 将登录状态保存到localStorage
    localStorage.setItem('userData', JSON.stringify({
      isLoggedIn: true,
      userInfo: {
        username: userData.username,
        role: 'admin'
      },
      token: userData.token,
      permission: userData.permission
    }))
    return true
  },
  
  logout({ commit }) {
    commit('LOGOUT')
    // 清除localStorage中的登录状态
    localStorage.removeItem('userData')
    localStorage.removeItem('user-permission')
  },
  
  // 检查是否已登录（页面刷新时使用）
  checkLoginStatus({ commit }) {
    const userData = localStorage.getItem('userData')
    if (userData) {
      try {
        let parsedData = JSON.parse(userData)
        
        // 处理旧格式数据（从phone属性迁移到username属性）
        if (parsedData.userInfo && parsedData.userInfo.phone && !parsedData.userInfo.username) {
          // 创建新格式数据
          const newUserData = {
            isLoggedIn: parsedData.isLoggedIn,
            userInfo: {
              username: parsedData.userInfo.phone,
              role: parsedData.userInfo.role || 'admin'
            },
            token: parsedData.token,
            permission: parsedData.permission || localStorage.getItem('user-permission')
          }
          
          // 更新localStorage
          localStorage.setItem('userData', JSON.stringify(newUserData))
          parsedData = newUserData
        }
        
        // 如果localStorage中有单独的user-permission，优先使用
        const permissionFromStorage = localStorage.getItem('user-permission')
        if (permissionFromStorage) {
          parsedData.permission = permissionFromStorage
        }
        
        commit('SET_LOGIN_STATUS', parsedData)
        return true
      } catch (error) {
        commit('LOGOUT')
        return false
      }
    }
    return false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}